import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { DynoList } from "../DynoList";

export const DomainComponent = ({
  domain,
  dynoStatuses,
  onDynoStatusChange,
  addDynoToClass,
  editDynoTitle,
}) => {
  return (
    <Box>
      {React.Children.toArray(
        domain?.topics.map((topic) => (
          <Box>
            <Box
              style={{
                background: "#216CF5",
                borderRadius: "20px",
                padding: "20px 10px",
                margin: "0 0 10px 0",
                color: "#fff",
              }}
            >
              <Text>{topic.name}</Text>
            </Box>
            {React.Children.toArray(
              topic.subTopics.map((subTopic) => (
                <Box>
                  <Box
                    style={{
                      background: "#C5A862",
                      borderRadius: "20px",
                      padding: "20px 10px",
                      margin: "0 0 10px 20px",
                      color: "#fff",
                    }}
                  >
                    <Text>{subTopic.name}</Text>
                  </Box>
                  <DynoList
                    dynos={subTopic.dynoes}
                    style={{
                      margin: "0 0 0 40px",
                    }}
                    dynoStatuses={dynoStatuses}
                    onDynoStatusChange={onDynoStatusChange}
                    addDynoToClass={addDynoToClass}
                    editDynoTitle={editDynoTitle}
                  />
                </Box>
              ))
            )}
          </Box>
        ))
      )}
    </Box>
  );
};
